import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NEOHUB_HOST } from '../../constants/hosts';

const Container = styled.div`
  padding: 1rem;
  background-color: #1399d6;
  color: #ffffff;
  font-family: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre;
  position: sticky;
  top: 0;
  z-index: 999;
`;

const Link = styled.a`
  color: #ffffff !important;
  font-family: inherit !important;
  text-decoration: underline;
  &:hover {
    color: #ffffff;
  }
`;

const mapStateToProps = ({ language }) => ({ language });

const OnboardingBanner = ({ language }) => {
  const link = (
    <Link
      href={`${NEOHUB_HOST}/onramp/review/summary?publish=true`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {language['returns.onboarding.banner.publish_link']}
    </Link>
  );

  const parts = language['returns.onboarding.banner.description'].split('$publishLink');
  const renderParts = parts
    .map((value, index) => (index === parts.length - 1 ? value : [value, link]))
    .flat();

  return <Container>{renderParts.map((comp) => comp)}</Container>;
};

OnboardingBanner.propTypes = {
  language: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(OnboardingBanner);
